import * as update from "immutability-helper";
import * as DTOS from "../FeralScan.dtos";
import {
    GET_METADATA_REQUEST,
    GET_METADATA_SUCCESS,
    GET_SURVEY_RESULTS_SUCCESS,
    GET_PLOT_EVENTS_COUNT_SUCCESS,
    IGetSurveyResultsSuccessAction,
    IGetPlotEventsCountSuccessAction,
    IGetMetadataSuccessAction,
} from "../actions/summarydata.actions";
import { IGetPlotSummaryDataSuccessAction, IGetPlotSeasonSummaryDataSuccessAction, GET_PLOT_SEASON_SUMMARY_DATA_REQUEST, GET_PLOT_SEASON_SUMMARY_DATA_SUCCESS, GET_PLOT_SUMMARY_DATA_REQUEST, GET_PLOT_SUMMARY_DATA_SUCCESS } from "../actions/data.actions";
import { string } from "prop-types";

export interface SurveyResults {
    surveyId: number;
    summaryResults: DTOS.IntegerData[];
    groupedUserResults: DTOS.GroupedData;
}

export type SummaryDataState = {
    metadata: any;
    loadingMetadata: boolean;
    surveyResults: SurveyResults[];
    plotEventsCountResults: DTOS.GraphNamedData[];

    plotSummaryData: any;
    plotSeasonSummaryDataLoading: boolean;
    plotSummaryDataLoading: boolean;
};

const initialState: SummaryDataState = {
    metadata: undefined,
    loadingMetadata: false,
    surveyResults: [],
    plotEventsCountResults: undefined,
    plotSummaryData: {},
    plotSeasonSummaryDataLoading: false,
    plotSummaryDataLoading: false,
};

export default function summarydata(state: SummaryDataState = initialState, action) {
    switch (action.type) {
        case GET_SURVEY_RESULTS_SUCCESS:
            return updateUserGroupSurveyResults(state, action);
        case GET_PLOT_EVENTS_COUNT_SUCCESS:
            return updatePlotEventsCount(state, action);
        case GET_METADATA_REQUEST:
            return setLoadingMetadata(state, true);
        case GET_METADATA_SUCCESS:
            return updateMetadata(state, action);


        case GET_PLOT_SEASON_SUMMARY_DATA_REQUEST:
            return updatePlotSeasonSummaryDataLoading(state, true);
        case GET_PLOT_SEASON_SUMMARY_DATA_SUCCESS:
            return updatePlotSeasonSummaryData(state, action);

        case GET_PLOT_SUMMARY_DATA_REQUEST:
            return updatePlotSummaryDataLoading(state, true);
        case GET_PLOT_SUMMARY_DATA_SUCCESS:
            return updatePlotSummaryData(state, action);
    }
    return state;
}

function updatePlotEventsCount(state: SummaryDataState, action: IGetPlotEventsCountSuccessAction): SummaryDataState {
    const newState: SummaryDataState = update(state, {
        plotEventsCountResults: {
            $set: action.data
        }
    })

    return newState;
}


function updateUserGroupSurveyResults(state: SummaryDataState, action: IGetSurveyResultsSuccessAction) {

    var inner: SurveyResults = {
        surveyId: action.surveyId,
        summaryResults: action.summaryResults,
        groupedUserResults: action.groupedUserResults,
    };

    var test: SurveyResults[] = [
        inner
    ];

    const indexOfExisting = state.surveyResults.findIndex(s => s.surveyId == action.surveyId);

    var newState: SummaryDataState = undefined;

    if (indexOfExisting !== -1) {
        newState = update(state, {
            surveyResults: { $splice: [[indexOfExisting, 1]] }
        });
    } else {
        newState = state;
    }

    const finalState: SummaryDataState = update(newState, {
        surveyResults: {
            $push: test
        }
    });

    return finalState;
}

function updateMetadata(state: SummaryDataState, action: IGetMetadataSuccessAction) {

    const result = action.userGroup !== undefined ? action.userGroup : action.user;

    const newState: SummaryDataState = update(state, {
        metadata: {
            $set: result
        }
    });

    return setLoadingMetadata(newState, false);
}

function setLoadingMetadata(state: SummaryDataState, loading: boolean) {
    const newState: SummaryDataState = update(state, {
        loadingMetadata: { $set: loading }
    });

    return newState;
}


function updatePlotSeasonSummaryDataLoading(state: SummaryDataState, isLoading: boolean) {
    const newState: SummaryDataState = update(state, {
        plotSeasonSummaryDataLoading: { $set: isLoading }
    })

    return newState;
}

function updatePlotSummaryDataLoading(state: SummaryDataState, isLoading: boolean) {
    const newState: SummaryDataState = update(state, {
        plotSummaryDataLoading: { $set: isLoading }
    })

    return newState;
}

function updatePlotSeasonSummaryData(state: SummaryDataState, action: IGetPlotSeasonSummaryDataSuccessAction): SummaryDataState {

    var newState: SummaryDataState = state;

    if (state.plotSummaryData[action.plotId] === undefined) {
        newState = update(newState, {
            plotSummaryData: {
                [action.plotId]: {
                    $set: {}
                }
            }
        });
    }

    for (var plot in newState.plotSummaryData) {
        newState = update(newState, {
            plotSummaryData: {
                [plot]: {
                    $merge: { plotSeasonSummaryData: action.plotSeasonSummaryData }
                }
            }
        });
    }

    return updatePlotSeasonSummaryDataLoading(newState, false);;
}

function updatePlotSummaryData(state: SummaryDataState, action: IGetPlotSummaryDataSuccessAction): SummaryDataState {

    var result = action.plotSummaryData.reduce(function (map, obj) {
        if (!map[obj.plotId]) {
            map[obj.plotId] = { summaryData: undefined }
        }

        map[obj.plotId].summaryData = obj;
        return map;
    }, {});

    var newState: SummaryDataState = state;

    for (var plot in result) {

        if (newState.plotSummaryData[plot] === undefined) {
            newState = update(newState, {
                plotSummaryData: {
                    [plot]: {
                        $set: {}
                    }
                }
            });
        }

        newState = update(newState, {
            plotSummaryData: {
                [plot]: {
                    $merge: { summaryData: result[plot].summaryData }
                }
            }
        });
    }

    return updatePlotSummaryDataLoading(newState, false);
}